import NumberFormat from 'react-number-format';
import { OrderStatus, KeyTypes } from '../../app/enums';
import { Typography, Grid} from '@material-ui/core';
import { OrderItem } from '../../models/order.interface';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    gridSpacer: {
      minHeight: '12px',
    },
    fontMediumBold: {
      fontSize: 14,
      color: theme.palette.text.primary,
      fontWeight: 'bold',
    },
    fontMedium: {
      fontSize: 14,
      color: theme.palette.text.primary,
    },
  }),
);

export interface IOrderItem {
  item: OrderItem
}

export const PrintOrderItem = (props: IOrderItem) => {
  const classes = useStyles();
  const item = props.item;

  let vehicle = item.vehicleInfo 
    ? <Typography className={classes.fontMediumBold}>
        {item.vehicleInfo.year} {item.vehicleInfo.make} {item.vehicleInfo.model}
      </Typography>
    : ''

  let vin = (item.vehicleInfo !== undefined && item.vehicleInfo.vin !== undefined)
    ? <Typography className={classes.fontMedium}>
        {item.vehicleInfo.vin}
      </Typography>
    : ''

  return (
    <>
      <Grid container className={classes.gridSpacer} />
      <Grid container spacing={0} justifyContent="space-between" alignItems="stretch">
        <Grid container justifyContent="space-between">
          {vehicle}
          <Typography className={classes.fontMediumBold}>
            <NumberFormat 
              value={item.price * item.quantity} 
              displayType={'text'} 
              thousandSeparator={true} 
              prefix={'$'} 
              decimalScale={2}
              fixedDecimalScale={true}
              />
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          {vin}
          <Typography className={classes.fontMedium}>
            each {'  '}
            <NumberFormat 
              value={item.price} 
              displayType={'text'} 
              thousandSeparator={true} 
              prefix={'$'} 
              decimalScale={2}
              fixedDecimalScale={true}
              />
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography className={classes.fontMedium}>
            {KeyTypes[item.keyType as keyof typeof KeyTypes]}
          </Typography>
          <Typography className={classes.fontMedium}>
            Qty: {item.quantity}
          </Typography>
        </Grid>
        {item?.lotNumber && 
          <Grid container>
            <Typography className={classes.fontMedium}>
              Lot #: {item.lotNumber}
            </Typography>
          </Grid>
        }
        {item?.sellerName && 
          <Grid container>
            <Typography className={classes.fontMedium}>
              Seller: {item.sellerName}
            </Typography>
          </Grid>
        }
        <Grid container justifyContent="space-between">
          <Typography className={classes.fontMedium}>
            Status: {OrderStatus[item.status as keyof typeof OrderStatus]}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default PrintOrderItem;